import { InvalidCredentialsError } from "../../../domain/errors/invalid-credentials-error";
import { UnexpectedError } from "../../../domain/errors/unexpected-error";
import { NationalService, NationalServiceModel } from "../../../domain/models/national-service";
import { HttpClient, HttpStatusCode } from "../../protocols/http/http-client";

export class RemoteNationalService implements NationalService {
  constructor(
    private readonly url: string,
    private readonly httpPostClient: HttpClient
  ) {}

  async loadByCnae(id: number): Promise<NationalServiceModel[]> {
    const httpResponse = await this.httpPostClient.request({
      url: `${this.url}/cnae/${id}`,
      method: "get",
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      case HttpStatusCode.badRequest:
        throw httpResponse.body;
      default:
        throw new UnexpectedError();
    }
  }

  async search(query: string): Promise<NationalServiceModel[]> {
    const httpResponse = await this.httpPostClient.request({
      url: this.url,
      method: "get",
      params: { query },
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      default:
        throw new UnexpectedError();
    }
  }
}
